<template>
  <modal name="wordCloud.textToShape"
    transition="nice-modal-fade"
    :width="422"
    height="auto"
    :min-height="598"
    :max-height="700"
    :classes="['custom']"
    :clickToClose="false"
    @before-open="beforeOpen"
    @opened="opened"
  >
    <div class="container" @keydown.stop
      v-loading="snapHandling"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="header">添加文本</div>
      <div class="content">
        <div class="setters">
          <input class="setter setter-input" v-model="text" maxlength="10"/>
          <div class="setter setter-bold" :class="{active: isBold}" @click="isBold = !isBold">B</div>
          <div class="setter setter-italic" :class="{active: isItalic}" @click="isItalic = !isItalic">I</div>
          <div class="setter setter-ff" @click="showFFDialog($event)">
            <span :style="{fontFamily: getFilename(currentFont)}">{{currentFont.title}}</span>
            <i class="triangle-icon"></i>
          </div>
          <div class="setter setter-invert" :class="{active: invertedData.active}" @click="invert">取反</div>
        </div>
        <div class="viewer">
          <div class="viewer__box">
            <ul
              class="char-list"
              :class="{bold: isBold, italic: isItalic}"
              :style="{
                fontFamily: getFilename(currentFont),
                backgroundColor: invertedData.active ? invertedData.bgc : shapeBgc
              }"
              ref="charList"
            >
              <li
                class="char"
                v-for="(item, i) in textArr" :key="i"
                v-html="item.char"
                :style="{color: invertedData.active ? invertedData.charColor : item.color}"
              >

              </li>
            </ul>
          </div>
        </div>
        <div class="pickers">
          <ul class="picker-list">
            <li
              class="picker"
              v-if="invertedData.active"
              style="width: auto;"
            >
              <div class="picker__char">基础色</div>
              <div
                class="picker__color" :style="{backgroundColor: invertedData.bgc}"
                @click="showColorPicker($event, invertedData.bgc, 0, 'textToShape.invert')"
              ></div>
            </li>
            <li
              class="picker"
              v-for="(item, i) in textArr" :key="i"
              v-if="!invertedData.active"
            >
              <div class="picker__char" v-html="item.char"></div>
              <div
                class="picker__color" :style="{backgroundColor: item.color}"
                @click="showColorPicker($event, item.color, i)"
              ></div>
            </li>
          </ul>
        </div>
      </div>
      <div class="hr"></div>
      <div class="footer">
        <div class="btn intereact-blue" @click="snap">添加形状</div>
        <div class="btn outline intereact-grey" @click="hide">取消</div>
      </div>
    </div>
  </modal>
</template>

<script>
import domtoimage from '@/plugins/dom-to-image';
import dti from 'dom-to-image';

function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type:mime});
}

function makeTransparent(aImg) {
  var canvas = document.createElement("canvas");

  var w = typeof aImg.naturalWidth == "undefined" ? aImg.width : aImg.naturalWidth;
  var h = typeof aImg.naturalHeight == "undefined" ? aImg.height : aImg.naturalHeight;

  // canvas.id = "img" + idx;
  canvas.width = w;
  canvas.height = h;

  $(aImg).replaceWith(canvas);

  var ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, w, h);
  ctx.drawImage(aImg, 0, 0);

  return _makeTransparent(aImg, ctx, canvas);
}

function _makeTransparent(aImg, ctx, canvas) {

  var w = typeof aImg.naturalWidth == "undefined" ? aImg.width : aImg.naturalWidth;
  var h = typeof aImg.naturalHeight == "undefined" ? aImg.height : aImg.naturalHeight;
  var imageData = ctx.getImageData(0, 0, w, h);

  for (var x = 0; x < imageData.width; x++)
    for (var y = 0; y < imageData.height; y++) {
      var offset = (y * imageData.width + x) * 4;
      var r = imageData.data[offset];
      var g = imageData.data[offset + 1];
      var b = imageData.data[offset + 2];

      //if it is pure white, change its alpha to 0
      if (r == 255 && g == 255 && b == 255) {
        imageData.data[offset] = 255;
        imageData.data[offset + 1] = 255;
        imageData.data[offset + 2] = 255;
        imageData.data[offset + 3] = 10;
      }
    };

  ctx.putImageData(imageData, 0, 0);
  // console.log("TCL: function_makeTransparent -> ctx.getImageData(0, 0, w, h)", ctx.getImageData(0, 0, w, h).data + '')
  return canvas.toDataURL();
}

export default {
  data () {
    return {
      text: '来画手绘',
      textArr: [],
      isBold: true,
      isItalic: false,
      shapeBgc: 'transparent',
      currentFont: {},
      invertedData: {
        active: false,
        charColor: '',
        bgc: '',
      },
      snapHandling: false,
    }
  },
  computed: {

  },
  watch: {
    text (val) {
      this.makeTextArr();
      this.$nextTick(() => {
        this.adaptWidth();
      })
    }
  },
  created () {
    this.$bus.on('font', (font, from) => {
      if (from === 'wordCloud.shape') {
        let filename = font.value.replace(/.+\//, '');
        let c = {};
        c.filename = filename;
        c.url = font.value;
        c.value = font.value;
        c.thumb = font.fontUrl;
        c.title = font.label;
        this.currentFont = c;

        // 在头部添加 @font-face, 会影响字体截图
        this.assignFont(filename, this.$handleAssetsUrl(font.value))

        this.$nextTick(() => {
          this.adaptWidth();
        })
      }
    });

    this.$bus.on(`cloud.colorPickerConfirm`, (obj, data) => {
      if (data.from === 'textToShape') {
        let item = this.textArr[data.itemIndex];
        this.$set(item, 'color', obj.hex);
      }
      if (data.from === 'textToShape.invert') {
        this.$set(this.invertedData, 'bgc', obj.hex);
      }
    });
  },
  mounted () {

  },
  methods: {
    beforeOpen (event) {
      this.$bus.emit('FeaturesPop_close_vue', {
        type: 3,
      });
      this.$bus.emit('wordCloud.hidePopups');
      this.currentFont = event.params.firstFont;
    },
    opened () {
      this.makeTextArr();
      this.$nextTick(() => {
        this.adaptWidth();
        this.invert();
      });
    },
    hide () {
      this.$modal.hide('wordCloud.textToShape');
    },
    makeTextArr () {
      this.textArr = this.text.split('').map((char, i) => {
        let newItem;
        if (this.textArr[i]) {
          newItem = {
            char: char === ' ' ? '&nbsp;' : char,
            color: this.textArr[i].color
          }
        } else {
          newItem = {
            char: char === ' ' ? '&nbsp;' : char,
            color: '#5778fb'
          };
        }

        return newItem;
      });
    },

    adaptWidth () {
      let $list = $('.char-list');
      let list = $('.char-list')[0];

      if (list.scrollWidth <= list.offsetWidth) {
        // let size = $list.css('fontSize');
        // size = parseInt(size);
        $list.css('fontSize', 300);
      }

      let innerSize = 0;
      $('.char').each((i, el) => {
        innerSize += el.offsetWidth;
      });
      let scrollWidth = list.scrollWidth;
      let charNum = this.text.length;
      let fontSize = $list.css('fontSize');
      fontSize = parseInt(fontSize);

      let listWidth = $list.outerWidth();
      do {
        fontSize -= 1;
        $list.css('fontSize', fontSize);
        let s = $list.css('fontSize');
        innerSize = this.getInnerSize();
        listWidth = $list.outerWidth();
      }
      while (listWidth > 386)
      // $list.css('fontSize', fontSize);
    },

    getInnerSize () {
      let innerSize = 0;
      $('.char').each((i, el) => {
        innerSize += el.offsetWidth;
      });
      return innerSize;
    },

    showFFDialog (ev) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue',{
				name : 'fontFamily',
				initialX : rect.left,
        initialY : rect.top + 10,
        posx: rect.left,
        posy: rect.top + 10,
        type : 1,
        // sprite: this.sprite,
        // source: this.$parent
        from: 'wordCloud.shape',
        refFont: this.currentFont,
			});
    },

    getFilename (font) {
      return '"' + font.filename + '"'
    },

    invert () {
      if (this.invertedData.active) {
        this.invertedData = {
          active: false,
          charColor: '',
          bgc: '',
        }
        return;
      }
      let charColor = this.textArr[0].color;
      this.invertedData = {
        active: true,
        charColor: '#fff',
        bgc: charColor,
      }
    },

    showColorPicker (ev, color, itemIndex, from) {
      let el = ev.currentTarget;
      let rect = el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color-cloud',
        // 使用了mixins popup.vue 下两字段就非必传
				posx : rect.left + rect.width,
				posy : rect.top - 150,
        type: 1,
        hasEyedropper: false,
        color: color,
        from: from || 'textToShape',
        itemIndex
      });
    },

    handleClone (dom) {
      let oldFontSize = parseFloat($(dom).css('font-size'))
      let wrapper = $('<div id="text-clone"></div>');
      wrapper.css({
        position: 'fixed',
        top: 0,
        'font-size': oldFontSize * 4 + 'px',
        'padding-left': '0.15em',
        'padding-right': '0.15em',
        'font-family': $(dom).css('font-family'),
        'background': $(dom).css('background')
      })
      $(dom).find('li').each((i, el) => {
        let item = $(`<div>${el.innerHTML}</div>`);
        item.css({
          display: 'inline',
          'line-height': 1.2,
          color: $(el).css('color')
        });
        item.appendTo(wrapper);
      });

      $('body').append(wrapper);
    },

    snapx () {
      let dom = this.$refs.charList;
      this.handleClone(dom);
      // window.html2canvas(dom).then(canvas => {
      //   document.body.appendChild(canvas)
      // });
    },

    snap () {
      if (this.snapHandling) {
        return;
      }
      this.snapHandling = true;

      let dom = this.$refs.charList;

      domtoimage.toPng2(dom, {
        // width: dom.offsetWidth * 2,
        // height: dom.offsetHeight * 2,
        // style: {
        //   transform: 'scale(2)'
        // }
        _width: dom.offsetWidth,
        _height: dom.offsetHeight,
        useFont: true,
        width: 1000,
        height: 1000 * dom.offsetHeight / dom.offsetWidth,
      })
        .then((async function (val) {
          // val is dataURL
          if (this.invertedData.active) {
            val = await this.handleImage(val);
          }
          return val;
        }).bind(this))
        .then((async function (val) {
          let blob = dataURLtoBlob(val);

          // let blobUrl = URL.createObjectURL(blob)
          // $('html').append(`<img id="bb" src='${blobUrl}' />`)

          let formData = new FormData();
          formData.append('wordCloudShape', blob);
          formData.append('png8', 1)

          this.$http({
            url: '/api/upload/file',
            method: 'post',
            data: formData,
          })
            .then(res => {
              let image = res.data.data;
              this.$http.post('/api/wordcloud/add', {
                url: image.filename,
                thumbnailUrl: image.thumbnailName,
                title: '',
                description: '',
              })
                .then(res => {
                  let shape = res.data.data;
                  this.$bus.emit('textToShapeDone', shape);
                  this.snapHandling = false;
                  this.hide();

                  this.$analysis('word_cloud,click_shape_confirm，文字云_点击_形状_确定')
                });
            })
            .catch(e => {
              console.warn("error: snap -> e", e);
              this.snapHandling = false;
            });
        }).bind(this))
        .catch(err => {
          this.snapHandling = false;
        })
    },

    handleImage (dataUrl) {
      return new Promise ((y, n) => {
        let img = new Image();
        img.onload = () => {
          let t = makeTransparent(img)
          y(t);
        }
        img.src = dataUrl

      })
    },

    assignFont (name, src) {
      var style = '<style type="text/css">\n' +
        '@font-face {' +
        'font-family: "' + name + '";' +
        'src: url("' + src + '");' + '</style>';

      $('head').prepend(style);
    }
  }
}
</script>

<style lang="scss" scoped>
$D: #5778fb;
.container {
  & * {
    color: #474261;
  }
  height: 100%;
  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
  background-color: #fff;

  & * {
    text-align: center;
  }
}
.header {
  width: 422px;
	height: 40px;
	line-height: 40px;
  padding-left: 1em;
	background-color: #d9ddea;
	border-radius: 8px 8px 0 0;
  text-align: left;
}
.content {
  padding-top: 1.2em;
}
.text {
  text-align: left;
  font-size: 14px;
  color: #474261;
  padding-left: 1em;
  margin-bottom: 0.6em;
}
textarea {
  width: 396px;
	height: 364px;
	background-color: #ffffff;
	border: solid 1px #d9ddea;
  padding: 1em;
  resize: none;
}
.hr {
  width: 396px;
	height: 2px;
	background-color: #f0f0f8;
  margin: auto;
}
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 72px;
  padding-right: 1em;
}
.btn {
  width: 100px;
	height: 34px;
  line-height: 34px;
	background-color: #5778fb;
	border-radius: 4px;
  margin-left: 0.8em;
  color: #fff;

  &.outline {
    background-color: #f4f4f8;
    border: solid 1px #d9ddea;
    color: #333;
  }
}

.setters {
  display: flex;
  align-items: center;
  justify-content: center;
}
.setter {
  margin-left: 4px;
  line-height: 34px;

  &:first-child {
    margin-left: 0;
  }

  &.active {
    color: #fff;
    background-color: $D;
  }
}

.setter-input {
  width: 146px;
	height: 34px;
	background-color: #f9f9fc;
	border: solid 1px #d9ddea;
  padding-left: 0.6em;
  text-align: left;
}

.setter-bold, .setter-italic {
  width: 34px;
	height: 34px;
	background-color: #f4f4f8;
	border-radius: 4px;
	border: solid 1px #d9ddea;
  font-weight: bold;
  font-size: 20px;

  &.active {
    color: #fff;
    background-color: $D;
  }

  &:hover {
    background-color: #dfdfe7 !important;
  }

  &.active {
    &:hover {
      background-color: #5656e8 !important;
      border-color: #5656e8 !important;
    }
  }
}
.setter-italic {
  font-style: italic;
  font-family: 'Times New Roman', Times, serif;
}

.setter-ff {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: stretch;
  width: 127px;
	height: 34px;
	background-color: #ffffff;
	border-radius: 4px;
	border: solid 1px #d9ddea;
  padding-left: 0.3em;
}

.setter-invert {
  width: 39px;
	height: 34px;
	background-color: #f4f4f8;
	border-radius: 4px;
  border: solid 1px #d9ddea;
  &:hover {
    background-color: #dfdfe7 !important;
  }

  &.active {
    &:hover {
      background-color: #5656e8 !important;
      border-color: #5656e8 !important;
    }
  }
}

.viewer {
  height: 364px;
  margin-top: 8px;

  &__box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 396px;
    height: 364px;
    margin: auto;
    background-color: #ffffff;
    border: solid 1px #d9ddea;
  }
}

.char-list {
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 386px;
  // font-size: 110px;
  font-size: 300px;
  padding-left: 0.15em;
  padding-right: 0.15em;

  &.bold {
    font-weight: bold;
  }
  &.italic {
    font-style: italic;
  }
}
.char {
  display: inline;
  line-height: 1.2;
}

.picker-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 396px;
  margin: auto;
}
.picker {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  margin-left: 0.5em;

  &__char {
    padding-right: 0.5em;
  }
  &__color {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    background-color: #5c5cff;
    border-radius: 4px;
    border: solid 1px #e6e8ef;
  }
}

.triangle-icon {
  position: absolute;
  right: .5em;
  top: 50%;
  transform: translateY(-50%);

  display: inline-block;
  width: 10px;
  height: 6px;
  background: url('../../../../../static/svg/inverted-triangle.svg') no-repeat center;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/modals/textToShape.vue